<template>
    <FormSection title="Physicians" :full-height="false">
        <template #content>
            <div class="row m-2 px-1">
                <div class="col-12 col-md-5">
                    <PatientPhysician
                        :label="primaryPhysicianLabel"
                        v-model:physicianId="certifyingPhysicianId"
                        :lineOfServiceValue="lineOfServiceValue"
                        :providerId="patient.providerId"
                        :accountId="accountId"
                        v-on:blurredInput="v$.patientDetails.certifyingPhysicianId.$touch"
                        :class="`${!v$.patientDetails.certifyingPhysicianId.$error ? '' : 'mb-0'}`"
                    />
                    <span v-if="v$.patientDetails.certifyingPhysicianId.$error" class="field-invalid"
                        >{{ primaryPhysicianLabel }} is required.</span
                    >
                </div>
                <div class="col-12 col-md-2 form-group">
                    <div class="form-check custom-checkbox form-check-inline pt-2 mt-4">
                        <input
                            type="checkbox"
                            id="same-as-attending"
                            class="form-check-input au-target"
                            :checked="sameAttending"
                            v-model="sameAttending"
                        />
                        <label class="form-check-label" for="same-as-attending">
                            <span class="me-1">Same as Attending</span>
                        </label>
                    </div>
                </div>
                <div class="col-12 col-md-5">
                    <PatientPhysician
                        label="Attending Physician"
                        v-model:physicianId="attendingPhysicianId"
                        :disabled="sameAttending"
                        :lineOfServiceValue="lineOfServiceValue"
                        :providerId="patient.providerId"
                        :accountId="accountId"
                        v-on:blurredInput="v$.patientDetails.attendingPhysicianId.$touch"
                        :class="`${!v$.patientDetails.attendingPhysicianId.$error ? '' : 'mb-0'}`"
                    />
                    <span v-if="v$.patientDetails.attendingPhysicianId.$error" class="field-invalid"
                        >Attending Physician is required.</span
                    >
                </div>
                <div class="col-12 col-md-4" v-for="(additionalPhysician, index) of patient?.additionalPhysicians">
                    <PatientPhysician
                        label="Additional Physician"
                        v-model:physicianId="patient.additionalPhysicians[index]"
                        :providerId="patient.providerId"
                        :accountId="accountId"
                    />
                </div>
                <div class="col-12">
                    <button class="btn btn-outline-primary" @click="addNewPhysician">
                        <i class="fas fa-plus"></i> Add Additional Physician
                    </button>
                </div>
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./Physicians.ts"></script>
